import { useRef } from 'react'

import { useColorPickerPreviewCommit } from '../useColorPickerPreviewCommit'
import { useColorPickerPreviewHexInput } from '../useColorPickerPreviewHexInput'
import { useColorPickerPreviewRgbInputs } from '../useColorPickerPreviewRgbInputs'
import { useColorPickerPreviewValueFocus } from '../useColorPickerPreviewValueFocus'

export function useColorPickerPopoverPreview({
  color,
  colorFormat,
  isPopoverOpen,
  onManualColorChange,
}) {
  const valueInputRef = useRef(null)
  const rgbInputRef = useRef(null)

  const { commitHex, tryCommitRgb } =
    useColorPickerPreviewCommit(onManualColorChange)

  const valueFocus = useColorPickerPreviewValueFocus({
    colorFormat,
    isPopoverOpen,
    rgbInputRef,
    valueInputRef,
  })

  const hexInput = useColorPickerPreviewHexInput({
    color,
    commitHex,
    isPopoverOpen,
    setIsValueInputFocused: valueFocus.setIsValueInputFocused,
  })

  const rgbInputs = useColorPickerPreviewRgbInputs({
    color,
    isPopoverOpen,
    setIsValueInputFocused: valueFocus.setIsValueInputFocused,
    tryCommitRgb,
  })

  return {
    ...hexInput,
    ...rgbInputs,
    handleValueTextTriggerClick: valueFocus.handleValueTextTriggerClick,
    handleValueTextTriggerKeyDown: valueFocus.handleValueTextTriggerKeyDown,
    isValueInputFocused: valueFocus.isValueInputFocused,
    rgbInputRef,
    valueInputRef,
  }
}
